import { Col, Row, Image, Menu } from 'antd';
import Link from 'next/link';
import { useRouter } from "next/router";
import { useState, useEffect, useRef } from 'react';
import { useSession, signIn, signOut } from "next-auth/react";
import UserProfileModal from "../pages/components/UserProfileModal"
import Avatar from "react-avatar";
import Modal from 'react-modal';
import styles from '../styles/UserProfile.module.css'
import { useTheme } from "next-themes";

export default function Sidebar({ sideMenuArrProp }) {
  const { data: session } = useSession();
  const [selectedPath, setSelectedPath] = useState(0);
  const router = useRouter();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sideMenuArr, setSideMenuArr] = useState(() => sideMenuArrProp ?? []);
  const [isModalHelp, setIsModalHelp] = useState(false);
  const { theme, setTheme } = useTheme();
  const [fctLogo, setFctLogo] = useState('/images/fctlogo1.png');
  const mediaQueryRef = useRef(null);
  // const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  useEffect(() => {

    let isMounted = true;

    mediaQueryRef.current = window.matchMedia('(prefers-color-scheme: dark)');
    const prefersDarkMode = mediaQueryRef.current.matches;
    if (isMounted) {
      if (theme === 'dark' || prefersDarkMode) {
        setFctLogo('/images/fctlogo1.png')
      }
      else {
        setFctLogo('/images/fc-logo-dark.png')
      }
    }
    return () => {
      isMounted = false;
      mediaQueryRef.current = null;
    };
  }, [theme])

  const openHelpModal = () => {
    setIsModalHelp(true);

  };
  const closeHelpModal = () => {
    setIsModalHelp(false);
  };

  const userRole = session?.user?.roles[0];


  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const userNameStyle = {
    color: 'white',
    fontWeight: 'bold'
  };
  const selected = {
    color: '#22b27e'
  }

  const unSelected = {
    color: 'white'
  }

  useEffect(() => {
    if (!session) {
      router.push("/");
    }
  }, [session]);

  useEffect(() => {
    let isMounted = true;
    if (localStorage.getItem('menubardata') && sideMenuArr.length <= 0) {
      const menuObj = localStorage.getItem('menubardata');
      if (isMounted && menuObj) {
        try {
          const menuBar = JSON.parse(menuObj);
          if (menuBar?.dashboard?.[2]?.sideMenu) {
            setSideMenuArr(menuBar?.dashboard?.[2]?.sideMenu || []);
          }
        } catch (err) {
          console.error('Failed to parse menubardata:', err);
        }
      }
    }
    return () => {
      isMounted = false;
    };
  }, [sideMenuArr.length]);




  const handleNavigation = (indexValue) => {

    if (userRole == 'Admin' || userRole == 'Internal User')  // userRole == 'New User'
    {
      switch (indexValue) {
        case 0:
          return '/admin-center/users'
        case 1:
          return '/admin-center/company'
        // case 2:
        //   return '/admin-center/role-security'
        // case 4:
        //   return '/admin-center/groups'
        // case 3:
        //   return '/admin-center/translation-profile'
        // case 5:
        //   return '/admin-center/qc-profile'
        // case 4:
        //   return '/admin-center/cad-processor'
        case 2:
          return '/jobs/all-jobs'
        // case 7:
        //   return '/admin-center/satellite-server'


        // default:
        //   // setSelectedPath(indexValue)
        //   // selectedIndexValue = indexValue
        //   return '/jobs/all-jobs'
        // break;
      }
    }
    else if (userRole == 'Internal Admin') {
      switch (indexValue) {
        case 0:
          return '/admin-center/users'
        case 1:
          return '/admin-center/company'
        //   case 2:
        //   return '/admin-center/role-security'
        // case 3:
        //   return '/admin-center/translation-profile'
        //    case 4:
        //   return '/admin-center/cad-processor'   
        case 2:
          return '/jobs/all-jobs'
      }
    }
    // else if (userRole == 'Admin') {
    //   switch (indexValue) {
    //     case 0:
    //       return '/admin-center/users'
    //     case 1:
    //       return '/admin-center/roles-security'
    //     case 2:
    //       return '/admin-center/groups'
    //     case 3:
    //       return '/admin-center/company'
    //     case 4:
    //       return '/admin-center/agent'
    //     case 5:
    //       return '/jobs/testExecution'
    //   }
    // }


    // else if (userRole == 'Interal Admin') {
    //   switch (indexValue) {
    //     case 0:
    //       return '/admin-center/users'
    //     case 1:
    //       return '/jobs/testExecution'
    //   }
    // }


  }

  const renderWidget = (indexValue) => {

    let path = handleNavigation(indexValue)
    setSelectedPath(indexValue)
    router.push(path);
  }

  return (
    <>
      <div className="main-sidebar">
        <Row align='middle' justify='space-between' className='sidebar-logo'>
          <Col>
            <Image src="/images/fctlogo1.png" alt="Logo" height={40} width={125} preview={false} />
            {/* <Image src='/images/one_logo_white_blue.png' alt="Logo" height={45}  preview={false} /> */}
          </Col>
        </Row>
        <ul className="sidebar-list">

          {/* {
            sideMenuArr && sideMenuArr.map((ele, index) => {
              let selectValue = selectedPath == index;

              return (
                <li key={index} onClick={() => renderWidget(index)} className={selectValue ? "active" : ""}>
                  <a style={selectValue ? selected : unSelected} >
                    <Image src={ele.path} className="img-active" preview={false} />
                    <Image src={ele.path} className="img-default" preview={false} />
                    <span>{ele.Name}</span>
                  </a>
                </li>

              )
            })
          } */}

          {
            sideMenuArr && sideMenuArr.map((item, index) => (
              <li key={index} className={router.pathname === item["URL"] ? "active" : ""}>
                <Link legacyBehavior href={item["URL"]} >
                  <a
                    style={
                      router.pathname === item["URL"] ? selected : unSelected
                    }
                  >
                    <Image src={item.path} className="img-active" preview={false} />
                    <Image src={item.path} className="img-default" preview={false} />
                    <span>{item.Name}</span>
                  </a>
                </Link>
              </li>
            ))
          }
        </ul>

        <div className='sidebarBottom'>
          {/* <hr /> */}
          <Row>
            <Col span={24}>
              <ul className="sidebar-list pb-10">
                <>
                  {/* <Avatar
                    // name={session ? session.user.name : ""}
                    name='?'
                    size="30"
                    onClick={openHelpModal}
                    title='Help'
                    round={true}
                    color=" rgb(12, 63, 107"
                    className='userProfile'
                  /> */}
                  {/* <span style={userNameStyle}>Help</span> */}

                  {
                    isModalHelp &&
                    <Modal
                      isOpen={isModalHelp}
                      // open={isModalHelp} 
                      // closable={closeHelpModal} 
                      // afterClose={closeHelpModal}
                      onRequestClose={closeHelpModal}
                      contentLabel="Application Version"
                      style={{
                        overlay: {
                          backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        }
                      }}
                      className={styles.userProfileModalPopup}
                    >
                      <div className={styles.modalHeader}>
                        <button className={styles.onRequestClose} onClick={closeHelpModal}>
                          <span>&times;</span>
                        </button>
                      </div>

                      <div className={styles.modalContent}>
                        <h3>Application Version</h3>
                        <p style={{ textAlign: 'center' }} className={styles.modelLabelValue}>EDX Version 2410</p>
                        {/* <p className={styles.bottomSpace}><strong className={styles.modelLabelTitle}>Name:</strong> <span className={styles.modelLabelValue}>Shree</span></p> */}
                        <div className={styles.PopUpLogo}>
                          <Image src={fctLogo} alt="Logo" height={28} preview={false} />
                        </div>
                      </div>
                    </Modal>
                  }
                </>
              </ul>
            </Col>
            <br />
            <br />
            <Col span={24}>
              <ul className="sidebar-list pb-10">
                <>
                  <Avatar
                    // name={session ? session.user.name : ""}
                    name={localStorage.name ? localStorage.name : ""}
                    size="30"
                    onClick={openModal}
                    round={true}
                    color=" rgb(12, 63, 107"
                    className='userProfile'
                  />
                  {/* <span style={userNameStyle}>  {session ? session.user.name : ""}</span> */}
                  <span style={userNameStyle}>  {localStorage.name ? localStorage.name : ""}</span>
                  <UserProfileModal
                    isOpen={isModalOpen}
                    onRequestClose={closeModal}
                  //user={session.user}
                  />
                </>
              </ul>
            </Col>
          </Row>
        </div>
      </div>
    </>
  )
}